import moment from 'moment';
import Intermediary from '../models/intermediary.model';
import Product from '../models/product.model';

let storeContent = utils.generateStore({
	Intermediary,
	Product,
	activeTab: 1,
	intermediary_page: 1,
	SelectedIntermediary: null,
	showIntermediary: false,
	showAppointmentForm: false,
	showChatUsers: false,
	showRecommendations: false,
	showIntermediaryRequest: false,
	intermediaries: [],
	intermediary_uploads: [],
	appointments: [],
	recommendations: [],
	request_items: [],
	proffesions: [],
	featured_intermediaries: [],
	result_intermediaries: [],
	quotation_requests: [],
	intermediary_requirement_fields: [],
	uploadPath: '',
	request_type: 'free',
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
		UPDATE_APPOINTMENT_STATUS(state, { id, status }) {
			const appointment = state.appointments.find(
				(a) => a.intermediary_appointment_id === id,
			);
			if (appointment) {
				appointment.appointment_decision = status;
			}
		},
	},
	actions: {
		async fetchProductCatalogue(ctx) {
			try {
				Event.$emit('loader:show', true);
				let res = await api.fetchEndpointSecure(
					{
						resource: 'subclass',
						action: 'list',
						data: {},
					},
					'/client',
				);

				let form = utils.appendSelectData({
					form: Intermediary.forms.select_category,
					model: 'insurance_category',
					label: 'name',
					// $labelSupport: 'currency_code',
					// $label: 'available_balance',
					data: res.result.insurance_sub_classes,
				});

				if (form) {
					let Model = ctx.getters.Intermediary;
					Model.forms.select_category = form;
					ctx.commit('Intermediary', Model);
				}

				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async selectProductCatalogue(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;

				if (await payload.ref.isValid()) {
					if (data.request_option === 'customized') {
						ctx.commit('request_type', 'customized');
						ctx.commit(
							'subClassCode',
							data.insurance_category.code,
						);
						await ctx.dispatch('fetchRequirementFields');

						if (ctx.getters.requirementFields.forms.length === 0) {
							$notify(
								'warning',
								'Missing Form Field',
								`The product selected have no form fields. Select another product or select <b>Fill the Form Fields</b> option on the Request Option Field`,
								10,
							);
							ctx.commit('loading', false);
							return true;
						}
						ctx.commit(
							'intermediary_requirement_fields',
							ctx.getters.requirementFields,
						);
					} else {
						ctx.commit('request_type', 'free');
					}
					ctx.commit('intermediary_page', 2);
				}
			} catch (err) {
				throw err;
			}
			ctx.commit('loading', false);
		},
		async setCustomizedProductForms(ctx, payload) {
			try {
				ctx.commit('loading', true);
				ctx.commit('request_items', []);
				let data = payload.ref.formData_;

				if (await payload.ref.isValid()) {
					let items = [];

					// Submit Uploads
					if (ctx.getters.intermediary_uploads) {
						for (
							let i = 0;
							i < ctx.getters.intermediary_uploads.length;
							i++
						) {
							const upload = ctx.getters.intermediary_uploads[i];
							if (upload.path && upload.path !== '') {
								data[upload.name] = upload.path;
							}
						}
					}

					for (const [key, data] of Object.entries(data)) {
						items.push({ name: key, value: data });
					}

					ctx.commit('request_items', items);
					ctx.commit('intermediary_page', 3);
				}
			} catch (err) {
				throw err;
			}
			ctx.commit('loading', false);
		},
		async setFreeProductForms(ctx, payload) {
			try {
				ctx.commit('loading', true);
				ctx.commit('request_items', []);
				let data = payload.ref.formData_;

				if (await payload.ref.isValid()) {
					ctx.commit('request_items', data.items);
					ctx.commit('intermediary_page', 3);
				}
			} catch (err) {
				throw err;
			}
			ctx.commit('loading', false);
		},
		async submitReview(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;

				if (await payload.ref.isValid()) {
					let res = await api.fetchEndpointSecure(
						{
							resource: 'intermediary',
							action: 'review',
							data: {
								intermediary_id:
									ctx.getters.SelectedIntermediary
										.intermediary_id,
								rating: data.rating,
								review: data.review,
							},
						},
						'/client',
					);

					ctx.commit('showAddReviews', false);
					$notify(
						'success',
						'Review Submitted',
						`Your review has been successfully submitted`,
						10,
					);
				}
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
			ctx.commit('loading', false);
		},
		async makeAnAppointment(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;
				console.log(
					moment(
						`${data.date} ${data.time}`,
						'DD-MM-YYYY HH:mm',
					).toISOString(),
				);

				if (await payload.ref.isValid()) {
					let res = await api.fetchEndpointSecure(
						{
							resource: 'Appointments',
							action: 'create_request',
							data: {
								Intermediary_id:
									ctx.getters.SelectedIntermediary
										.intermediary_id,
								appointment_date: moment(
									`${data.date} ${data.time}`,
									'DD-MM-YYYY HH:mm',
								).toISOString(),
								appointment_time: data.time,
								appointment_subject: data.subject,
								appointment_description: data.description,
								client_details: {},
								to: 'INTERMEDIARY',
								from: 'CLIENT',
							},
						},
						'/client',
					);

					await ctx.dispatch('fetchAppointments');
					ctx.commit('showAppointmentForm', false);
					$notify(
						'success',
						'Appointment Booked',
						`Appointment successfully booked.`,
						10,
					);
				}
				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async fetchProductReviews(ctx) {
			try {
				Event.$emit('loader:show', true);

				let res = await api.fetchEndpointSecure(
					{
						resource: 'intermediary',
						action: 'list_reviews',
						data: {
							intermediary_id:
								ctx.getters.SelectedIntermediary
									.intermediary_id,
						},
					},
					'/client',
				);

				ctx.commit('product_reviews', res.result.intermediary_reviews);

				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async fetchIntermediaryChatUsers(ctx) {
			try {
				Event.$emit('loader:show', true);

				let res = await api.fetchEndpointSecure(
					{
						resource: 'chat',
						action: 'get_entity_chat_group',
						data: {
							entity: {
								entity_id: `${ctx.getters.SelectedIntermediary.intermediary_id}`,
								entity_type: 'INTERMEDIARY',
							},
						},
					},
					'/client',
				);

				let form = utils.appendSelectData({
					form: Intermediary.forms.chat_users,
					model: 'chat_user',
					label: 'names',
					$labelSupport: 'names',
					$label: 'email',
					data: res.result.users,
				});

				if (form) {
					let Model = ctx.getters.Intermediary;
					Model.forms.chat_users = form;
					ctx.commit('Intermediary', Model);
				}

				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async goToChat(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;

				if (await payload.ref.isValid()) {
					let res = await api.fetchEndpointSecure(
						{
							resource: 'chat',
							action: 'get_chat_conversation_id',
							data: {
								from_chat_user_id:
									ctx.getters.chat_id ||
									(await $session.get('chat_id')),
								user_id: data.chat_user.user_id,
							},
						},
						'/client',
					);

					ctx.commit('showChatUsers', false);
					ctx.commit('selected_chat_user', data.chat_user);
					payload.router.push({ name: 'Chats' });
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async listQuotationRequests(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'quotation_request',
						action: 'intermediary',
						data: {
							intermediary_id:
								ctx.getters.SelectedIntermediary
									.intermediary_id,
						},
					},
					'/client',
				);

				ctx.commit('quotation_requests', res.result.quotation_requests);
			} catch (err) {
				throw err;
			}
		},

		async fetchAppointments(ctx) {
			let loggedInUser = await $session.get('user');
			try {
				Event.$emit('loader:show', true);
				let res = await api.fetchEndpointSecure(
					{
						resource: 'Appointments',
						action: 'list_my_appointments',
						data: {
							intermediary_id:
								ctx.getters.SelectedIntermediary
									.intermediary_id,
							client_email: loggedInUser.contact,
						},
					},
					'/client',
				);

				let my_appointment_res = await api.fetchEndpointSecure(
					{
						resource: 'Appointments',
						action: 'list_my_appointments_v3',
						data: {
							intermediary_id:
								ctx.getters.SelectedIntermediary
									.intermediary_id,
							// client_email: loggedInUser.contact
						},
					},
					'/client',
				);

				let results = [
					...res.result.client_appointments,
					...my_appointment_res.result.client_appointments,
				];

				ctx.commit('appointments', results);
				console.log('appintmets', results);

				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},

		async rejectAppointment({ commit }, appointment) {
			let loggedInUser = await $session.get('user');
			try {
				Event.$emit('loader:show', true);
				let res = await api.fetchEndpointSecure(
					{
						resource: 'Appointments',
						action: 'reject_appointment',
						data: {
							intermediary_appointment_id:
								appointment.intermediary_appointment_id,
							//client_email: loggedInUser.contact
						},
					},
					'/client',
				);

				commit('UPDATE_APPOINTMENT_STATUS', {
					id: appointment.intermediary_appointment_id,
					status: 'REJECTED',
				});
				// ctx.commit('appointments', res.result.client_appointments)
				console.log('appintmets res reject', res);

				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async acceptAppointment({ commit }, appointment) {
			let loggedInUser = await $session.get('user');
			try {
				Event.$emit('loader:show', true);
				let res = await api.fetchEndpointSecure(
					{
						resource: 'Appointments',
						action: 'accept_appointment',
						data: {
							intermediary_appointment_id:
								appointment.intermediary_appointment_id,
							// client_email: loggedInUser.contact
						},
					},
					'/client',
				);

				commit('UPDATE_APPOINTMENT_STATUS', {
					id: appointment.intermediary_appointment_id,
					status: 'APPROVED',
				});
				// ctx.commit('appointments', res.result.client_appointments)
				console.log('appintmets res accept', res);

				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},

		async fetchQuotationRecommendations(ctx, quotation_request) {
			console.log('fq', ctx);
			try {
				if (quotation_request.request_stage !== 'CLIENT') {
					$notify(
						'warning',
						'Recommendations Not Defined',
						`The intermediary has not submitted the recommendations for this quotation request`,
						10,
					);
					return true;
				}

				Event.$emit('loader:show', true);

				let res = await api.fetchEndpointSecure(
					{
						resource: 'quotation_request',
						action: 'list_recommendations',
						data: {
							system_quotation_request_ref:
								quotation_request.system_quotation_request_ref,
						},
					},
					'/client',
				);

				console.log(
					'fetching quotations.......',
					res.result.recommendations,
				);

				ctx.commit('recommendations', res.result.recommendations);
				ctx.commit('showRecommendations', true);

				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async acceptQuotation(ctx, quotation) {
			try {
				Event.$emit('loader:show', true);

				let res = await api.fetchEndpointSecure(
					{
						resource: 'quotation_request',
						action: 'accept_v1',
						data: {
							system_quotation_request_recommendation_ref:
								quotation.system_quotation_request_recommendation_ref,
						},
					},
					'/client',
				);

				console.log('RES+++ accepting quotation', res);

				Event.$emit(
					'quotation:purchase',
					res.result.system_quotation_ref,
				);
				ctx.commit('showRecommendations', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async fetchProffesion(ctx) {
			try {
				Event.$emit('loader:show', true);

				let res = await api.fetchEndpointSecure(
					{
						resource: 'intermediary',
						action: 'get_profession',
						data: {
							intermediary_id:
								ctx.getters.SelectedIntermediary
									.intermediary_id,
						},
					},
					'/client',
				);

				ctx.commit('proffesions', res.result.intermidiary_proffesion);

				let form = utils.appendSelectData({
					form: Intermediary.forms.select_category,
					model: 'insurance_category',
					label: 'name',
					// $labelSupport: 'currency_code',
					// $label: 'available_balance',
					data: res.result.intermidiary_proffesion,
				});

				if (form) {
					let Model = ctx.getters.Intermediary;
					Model.forms.select_category = form;
					ctx.commit('Intermediary', Model);
				}
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async requestQuote(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;

				if (await payload.ref.isValid()) {
					let request_type = 'form';
					if (ctx.getters.request_type === 'free') {
						request_type = 'upload';
					}

					console.log('RQ', ctx);
					let res = await api.fetchEndpointSecure(
						{
							resource: 'quotation_request',
							action: 'create_request',
							data: {
								insurance_sub_classes: ctx.getters.subClassCode,
								request_type,
								upload_path: ctx.getters.uploadPath,
								sum_assured: ctx.getters.sum_assured,
								reg_no: ctx.getters.reg_no,
								engine_capacity: ctx.getters.engine_capacity,
								entity_type: 'INTERMEDIARY',
								intermediary_id:
									ctx.getters.SelectedIntermediary
										.intermediary_id,
								remarks: data.remarks,
								quotation_form: ctx.getters.request_items,
							},
						},
						'/client',
					);

					ctx.commit('intermediary_uploads', []);
					$notify(
						'success',
						'Request Submitted',
						`Your request has been successfully submitted`,
						10,
					);
					ctx.commit('showIntermediaryRequest', false);
					ctx.commit('showIntermediary', false);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},

		async uploadFilesIntermediary(ctx, event) {
			try {
				let user = await $session.get('user');
				ctx.commit('uploadPath', '');

				if (user && user.user_id) {
					for (let i = 0; i < event.files.length; i++) {
						const file = event.files[i];
						let res = await ctx.dispatch('uploadFileIntermediary', {
							file,
							name: 'intermediary_file',
						});
						ctx.commit('uploadPath', res.res.result.file_path);
						let intermediary_uploads =
							ctx.getters.intermediary_uploads;
						intermediary_uploads.push({
							name: event.name,
							path: res.res.result.file_path,
						});
						ctx.commit(
							'intermediary_uploads',
							intermediary_uploads,
						);
					}
				}
			} catch (err) {
				$notify(
					'error',
					'Upload Fail',
					`Upload for ${'intermediary_file'} failed. Try again`,
				);
				throw err;
			}
		},
		async uploadFileIntermediary(ctx, payload) {
			console.log('intr upload form', payload.file);
			try {
				let bodyFormData = new FormData();
				bodyFormData.append('file', payload.file);
				let res = await api.upload(
					api.parseRoute('upload/v1/client'),
					bodyFormData,
					payload.name,
				);
				console.log('res upload', res);
				$notify(
					'success',
					'Uploading File',
					`File uploaded successfully for unit ${payload.name}`,
				);

				return res;
			} catch (err) {
				throw err;
			}
		},
		async listIntermediaries(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'intermediary',
						action: 'list',
						data: {},
					},
					'/client',
				);

				ctx.commit('intermediaries', res.result.intermediaries);
			} catch (err) {
				throw err;
			}
		},
		async fetchRecommendations(ctx) {
			try {
				Event.$emit('loader:show', true);
				// let res = await api.fetchEndpointSecure({
				//    resource: "intermediary",
				//    action: "list",
				//    data: {}
				// }, '/client')

				// ctx.commit('intermediaries', res.result.intermediaries)
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async fetchFeaturedIntermediaries(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'intermediary',
						action: 'list',
						data: {},
					},
					'/client',
				);
				console.log('fs', res);

				ctx.commit('result_intermediaries', res.result.intermediaries);
				ctx.commit(
					'featured_intermediaries',
					res.result.intermediaries.filter((el) => {
						if (
							el.image_path &&
							el.image_path !== '' &&
							el.intermediary_names !== '' &&
							el.description !== ''
						) {
							return true;
						}
					}),
				);
			} catch (err) {
				throw err;
			}
		},
		async fetchMainData(ctx) {
			try {
				await ctx.dispatch('fetchFeaturedIntermediaries');
				Event.$emit('loader:show', false);
			} catch (err) {
				throw err;
			}
		},
		async fetchData(ctx) {
			try {
				await ctx.dispatch('listIntermediaries');
				await ctx.dispatch('getSelection');
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async getSelection(ctx) {
			try {
				let selected = await $session.get('selected_intermediary:get');

				if (selected) {
					for (const intermediary of ctx.getters.intermediaries) {
						if (intermediary.intermediary_id === Number(selected)) {
							ctx.dispatch('openModal', {
								number: 1,
								intermediary,
							});
							$session.remove('selected_intermediary:get');
							return true;
						}
					}
				}
			} catch (err) {
				throw err;
			}
		},
		closeModal(ctx, number) {
			switch (number) {
				case 1: {
					ctx.commit('showIntermediary', false);
					break;
				}
			}
		},
		openTab(ctx, number) {
			ctx.commit('activeTab', number);
		},
		async openModal(ctx, payload) {
			switch (payload.number) {
				case 1: {
					ctx.commit('showIntermediary', true);
					ctx.commit('SelectedIntermediary', payload.intermediary);
					await ctx.dispatch('fetchAppointments');
					await ctx.dispatch('fetchProffesion');
					await ctx.dispatch('listQuotationRequests');
					break;
				}
			}
		},
	},
};
